import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './OverlapSection.m.css';

const bottom = require('../assets/images/header-section-backgrounds/section-mask-bottom-large.svg');

export interface OverlapSectionProperties {
	/**  */
	shaded?: boolean;
	/** */
	type?: 'trailing' | 'standard';
}

const factory = create().properties<OverlapSectionProperties>();

export const OverlapSection = factory(function OverlapSection({ properties, children }) {
	const { shaded, type } = properties();
	return (
		<div classes={[css.root, type === 'trailing' && css.trailing]}>
			{shaded && <div classes={[css.top]} />}
			<div classes={[css.content, shaded && css.shaded]}>{children()}</div>
			{shaded && <img classes={[css.bottom]} src={bottom} alt="" />}
		</div>
	);
});

export default OverlapSection;
